module.exports = __webpack_public_path__ + "static/media/Experience Design.746f7834.svg";